<template>
  <div class="mt-6 pb-6">
    <h1 class="mt-5 fw-6 text-center">{{ isBsgzw ? '合作伙伴' : '他们都在招采金服' }}</h1>
    <div class="e-flex jc-center mt-4 mb-4 container">
      <div
        class="boxItem"
        v-for="(item, index) in dataList"
        :key="index"
        :title="item.title"
      >
        <img :src="item.logo" :alt="item.title" />
      </div>
    </div>
  </div>
</template>

<script>
import { friendList } from './Json'
export default {
  data() {
    return {
      dataList: friendList,
    }
  },
  computed: {
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
  }
}
</script>

<style scoped lang="scss">
.boxItem {
  width: 240px;
  height: 120px;
  border: 1px solid #e4e4e4;
  background-color: white;
  img {
    width: 100%;
  }
}
</style>
